export class BlipCommandHeader {
  "Content-Type": string;
  Authorization: string;

  public constructor(botKey: string, contentType: string = "application/json") {
    this.Authorization = botKey;
    this["Content-Type"] = contentType;
  }
}
